import { Component, OnInit, Input, Output, EventEmitter, ViewChildren } from '@angular/core';
import { OrderItem } from '../../../api/models/order-item';
import { Advisory } from '../../../api/models/product';

@Component({
    selector: 'app-product-advisories-details',
    templateUrl: './product-advisories-details.component.html',
    styleUrls: ['./product-advisories-details.component.scss']
  })
  export class ProductAdvisoriesDetailsComponent implements OnInit {
    @Input() orderItem: OrderItem;
    @Output() quoteAdvisory = new EventEmitter<{ bomLineId: string, advisory: Advisory}>();
    @ViewChildren('typeOneAdvisoryInput') typeOneAdvisoryInputs;

    ngOnInit() { 
      //Empty ngOnInit() method
    }

    setQuoteAdvisories(bomLineId: string, advisory: Advisory, event: any) {
        let advisoryAnswer = `${event.target.value}`;
        advisory.value = advisoryAnswer;
        this.quoteAdvisory.emit({bomLineId: bomLineId, advisory: advisory});
    }
  }



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/product-advisories/product-advisories-details/product-advisories-details.component.ts